import Vue from 'vue'
//base 64 javascript 
//https://github.com/pocka/bitwise64
const b64 = require('bitwise64');

const access_codes = {
	SUPER_ADMIN : "9223372036854775807",
	CREATE_SALE : "1",
	USERS : "2",
	CREATE_LOCATION : "4",
	STOCK_TRANSFER : "8",
	CREATE_PURCHASE : "16",
	CREATE_CUSTOMER : "32",
	VIEW_DASHBOARD : "64",
	VIEW_BUSINESS_DETAILS : "128",
	VIEW_CUSTOMERS : "256",
	VIEW_CUSTOMER_DETAILS : "512",
	DELETE_CUSTOMER : "1024",
	CREATE_EXPENSE : "2048",
	VIEW_EXPENSES : "4096",
	DELETE_EXPENSE : "8192",
	CREATE_EXPENSE_TYPE : "16384",
	VIEW_EXPENSE_TYPES : "32768",
	DELETE_EXPENSE_TYPES : "65536",
	VIEW_STOCK : "131072",
	VIEW_LOCATIONS : "262144",
	DELETE_LOCATION : "524288",
	CREATE_UNIT_OF_MEASURE : "1048576",
	VIEW_UNITS_OF_MEASURE : "2097152",
	DELETE_UNITS_OF_MEASURE : "4194304",
	CREATE_BRAND : "8388608",
	VIEW_BRANDS : "16777216",
	DELETE_BRAND : "33554432",
	CREATE_CATEGORY : "67108864",
	VIEW_CATEGORIES : "134217728",
	DELETE_CATEGORY : "268435456",
	CREATE_PRODUCT : "536870912",
	VIEW_PRODUCTS : "1073741824",
	DELETE_PRODUCT : "2147483648",
	CREATE_GROUP : "4294967296",
	VIEW_GROUPS : "8589934592",
	DELETE_ITEM_GROUP : "17179869184",
	CREATE_SUPPLIER : "34359738368",
	VIEW_SUPPLIER : "68719476736",
	CREATE_ORDER : "137438953472",
	VIEW_ORDER : "274877906944",
	CREATE_SHIPMENT : "549755813888",
	VIEW_SHIPMENT : "1099511627776",
	VIEW_SALES : "2199023255552",
	VIEW_DEBTS : "4398046511104",
	SETTLE_DEBT : "8796093022208",
	VIEW_CUSTOMER_STATEMENT : "17592186044416",
	VIEW_TRADE_BALANCES : "35184372088832",
	STOCK_ADJUSTMENT : "70368744177664",
	CREATE_RETURN : "140737488355328",
	DELETE_RETURN : "281474976710656",
	LIST_RETURN : "562949953421312",
	// PERMISSION_52 : "1125899906842624",
	// PERMISSION_53 : "2251799813685248",
	// PERMISSION_54 : "4503599627370496",
	// PERMISSION_55 : "9007199254740992",
	// PERMISSION_56 : "18014398509481984",
	// PERMISSION_57 : "36028797018963968",
	// PERMISSION_58 : "72057594037927936",
	// PERMISSION_59 : "144115188075855872",
	// PERMISSION_60 : "288230376151711744",
	// PERMISSION_61 : "576460752303423488",
	// PERMISSION_62 : "1152921504606846976",
	// PERMISSION_63 : "2305843009213693952",
	// PERMISSION_64 : "4611686018427387904"
}

const report_codes = {
	SUPER_PERMISIONS_ADMIN : "9223372036854775807",
	SALES_PER_PRODUCT : "1",
	SALES_PER_CUSTOMER : "2",
	SALES_PER_LOCATION : "4",
	SALES_PER_PAYMENT_METHOD : "8",
	MPESA_PAYMENTS_REPORT : "16",
	SALES_PER_USER : "32",
	CUSTOMERS_PER_USER_REPORT : "64",
	USER_CUSTOMERS_REPORT : "128",
	PRODUCT_PERFORMANCE : "256",
	RETURNS_PER_PRODUCT : "512",
	SPECIFIC_PRODUCT_RETURNS : "1024",
	TRANSFER_PER_PRODUCT : "2048",
	TRANSFER_PER_LOCATION_PAIR : "4096",
	EXPENSES_PER_EXPENSE_TYPE : "8192",
	EXPENSES : "16384",
	EXPENSES_PER_LOCATION : "32768",
	GROSS_PROFIT_PER_SALE : "65536",
	GROSS_PROFIT_PER_PRODUCT : "131072",
	GROSS_PROFIT_PER_USER : "262144",
	GROSS_PROFIT_PER_LOCATION : "524288",
	GROSS_PROFIT_PER_CUSTOMER : "1048576",
	PURCHASE_PER_PRODUCT : "2097152",
	PURCHASE_PER_SUPPLIER : "4194304",
	// PERMISSION_24 : "8388608",
	// PERMISSION_25 : "16777216",
	// PERMISSION_26 : "33554432",
	// PERMISSION_27 : "67108864",
	// PERMISSION_28 : "134217728",
	// PERMISSION_29 : "268435456",
	// PERMISSION_30 : "536870912",
	// PERMISSION_31 : "1073741824",
	// PERMISSION_32 : "2147483648",
	// PERMISSION_33 : "4294967296",
	// PERMISSION_34 : "8589934592",
	// PERMISSION_35 : "17179869184",
	// PERMISSION_36 : "34359738368",
	// PERMISSION_37 : "68719476736",
	// PERMISSION_38 : "137438953472",
	// PERMISSION_39 : "274877906944",
	// PERMISSION_40 : "549755813888",
	// PERMISSION_41 : "1099511627776",
	// PERMISSION_42 : "2199023255552",
	// PERMISSION_43 : "4398046511104",
	// PERMISSION_44 : "8796093022208",
	// PERMISSION_45 : "17592186044416",
	// PERMISSION_46 : "35184372088832",
	// PERMISSION_47 : "70368744177664",
	// PERMISSION_48 : "140737488355328",
	// PERMISSION_50 : "281474976710656",
	// PERMISSION_51 : "562949953421312",
	// PERMISSION_52 : "1125899906842624",
	// PERMISSION_53 : "2251799813685248",
	// PERMISSION_54 : "4503599627370496",
	// PERMISSION_55 : "9007199254740992",
	// PERMISSION_56 : "18014398509481984",
	// PERMISSION_57 : "36028797018963968",
	// PERMISSION_58 : "72057594037927936",
	// PERMISSION_59 : "144115188075855872",
	// PERMISSION_60 : "288230376151711744",
	// PERMISSION_61 : "576460752303423488",
	// PERMISSION_62 : "1152921504606846976",
	// PERMISSION_63 : "2305843009213693952",
	// PERMISSION_64 : "4611686018427387904"
}

Vue.prototype.$access_codes = access_codes
Vue.prototype.$report_codes = report_codes

//check if a user has permission.
Vue.prototype.$hasPermission = function(){	
	// given permission name only, Then get authosrization code from 	localStorage
	if(arguments.length == 1){
		var authorisationCode = parseInt(localStorage.getItem('auth_code'))		
		// get permission_code from name
		var permission_name = arguments[0]
		var permission_code = access_codes[permission_name]
		if (permission_code === undefined){
			permission_code = report_codes[permission_name]
		}
		permission_code = parseInt(permission_code)
		return b64.and(authorisationCode,permission_code) === permission_code//bitwise
	}	
	// given authorization code and permission code (consumed when rendering users)
	if(arguments.length == 2){
		authorisationCode = parseInt(arguments[0])
		permission_code = parseInt(arguments[1])
		return b64.and(authorisationCode,permission_code) === permission_code//bitwise
	}
}

//combine permissions.
Vue.prototype.$newPermissionCode = function(args){
	var new_permission_code = parseInt(args[0].code)
	for (var i in args){
		new_permission_code = b64.or(new_permission_code,args[i].code)
	}
	return new_permission_code
}